/* global axios */
import ApiClient from './ApiClient';

class TalkviaReferralAPI extends ApiClient {
  constructor() {
    super('talkvia_referral', { accountScoped: true });
  }

  regenerateCode() {
    return axios.patch(`${this.url}/regenerate_code`);
  }
}

export default new TalkviaReferralAPI();
